import React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
/** @jsxImportSource @emotion/react */
import { jsx } from "@emotion/react";
import styled from "@emotion/styled";
import { withStyles } from "@material-ui/core/styles";
import MuiTabs from "@material-ui/core/Tabs";

import { useBreakpoints } from "common/hooks";

import { Tab, Tabs } from "./Styles";

const reverseShadow = "0px -4px 10px 2px rgba(0,0,0,0.1)";

const MobileTabsBase = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background[4],
    marginTop: 5,
    position: "fixed",
    zIndex: theme.zIndex.appBar,
    bottom: 0,
    left: 0,
    right: 0,
    boxShadow: reverseShadow,
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    top: 0,
    "& > span": {
      height: 3,
      maxWidth: 30,
      width: "100%",
      backgroundColor: theme.palette.text.primary,
    },
  },
}))((props) => (
  <MuiTabs {...props} TabIndicatorProps={{ children: <span /> }} />
));
const MobileTabs = styled(MobileTabsBase)((props) => ({
  ".Mui-selected": {
    color: props.theme.palette.text.primary,
    // fontWeight: 500,
  },
}));

export default function CustomTabs({ children, ...props }) {
  const bp = useBreakpoints();
  const businessUid = useParams().id;
  const history = useHistory();
  const location = useLocation();
  const route = location?.pathname?.split?.("/")?.[2] ?? "overview";
  const TabsCls = bp.lessThan.lg ? MobileTabs : Tabs;

  const handleChange = (event, value) => {
    history.push(`/${businessUid}/${value}${history.location.search}`);
  };

  return (
    <TabsCls
      onChange={handleChange}
      value={route}
      indicatorColor="primary"
      variant="scrollable"
      scrollButtons="auto"
      {...props}
    >
      {children}
    </TabsCls>
  );
}
